/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export const DEFAULT_ERROR_MESSAGE = 'There was an error';

export const DATE_FORMAT = 'yyyy-MM-dd';

export enum PeriodOptions {
  DoesNotRepeat = 'Does not repeat',
  Custom = 'Custom repeat',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY',
  Annually = 'ANNUALLY',
  Yearly = 'YEARLY',
}

export enum StopRepeatingOptions {
  Never = 'Never',
  On = 'On',
  After = 'After',
}

export const Layout = {
  Presenter: {
    TwoThirds: {
      presenterClass: 'w-66',
    },
    Half: {
      presenterClass: 'w-50',
    },
    Quarter: {
      presenterClass: 'w-25',
    },
  },
  Columns: {
    Full: {
      columnClass: 'col-md-12',
    },
    TwoThirds: {
      columnClass: 'col-md-8',
    },
    Half: {
      columnClass: 'col-md-6',
    },
    Quarter: {
      columnClass: 'col-md-3',
    },
    Third: {
      columnClass: 'col-md-4',
    },
  },
};

export const WeekDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
